import { render, staticRenderFns } from "./ProfileVerifyingConfirm.vue?vue&type=template&id=c0dbc1d0&scoped=true&"
import script from "./ProfileVerifyingConfirm.vue?vue&type=script&lang=ts&"
export * from "./ProfileVerifyingConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileVerifyingConfirm.vue?vue&type=style&index=0&id=c0dbc1d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0dbc1d0",
  null
  
)

export default component.exports